import { storage } from '@/helpers/storage'

import { AB_KEY, getExperiments } from './storage'
import { Experiment } from './types'

/**
 * Return the assigned variant for the specified `experiment`.
 *
 * This function does the same as `ab.experimentVariant`, but using only
 * `localStorage` instead of our `storage` wrapper. It's meant to be
 * used in inline scripts in the HTML of public pages, so we want
 * to keep it with as few dependencies as possible.
 */
export function experimentVariant<T extends string>(
  experiment: Experiment,
): T | null {
  const experiments = localStorage.getItem(AB_KEY)
  if (!experiments) {
    return null
  }

  const variant = JSON.parse(experiments)[experiment]
  return variant || null
}

/**
 * Get a random value from the given `variants`.
 */
export function assignVariant<T extends string>(variants: T[]): T {
  const randomIndex = Math.floor(Math.random() * variants.length)
  return variants[randomIndex]
}

// Key for the variant to set in `localStorage` for the exp_persistent_partnership_offer_17477 experiment.
export const VARIANT_TO_SET_17477_KEY = 'variant_to_set_17477'

// True if the user is in variant B (including pending assignment before `savePersistentPartnershipOffer17477Variant` runs). */
export function isVariantB17477(): boolean {
  if (storage.getItem(VARIANT_TO_SET_17477_KEY) === 'B') {
    return true
  }
  return (
    getExperiments()[Experiment.exp_persistent_partnership_offer_17477] === 'B'
  )
}
